import PropTypes from 'prop-types';

import { DIRECTION } from '@/common/constants';
import {
  ChildrenDefaultProps,
  ChildrenPropTypes,
} from '@/common/proptypes/Base/Children.proptypes';
import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const ScrollListDefaultProps = {
  ...ChildrenDefaultProps,
  ...ClassNameDefaultProps,
  direction: DIRECTION.HORIZONTAL,
  scrollbar: false,
  speed: 1,
};

export const ScrollListPropTypes = {
  ...ChildrenPropTypes,
  ...ClassNamePropTypes,
  direction: PropTypes.oneOf([DIRECTION.HORIZONTAL, DIRECTION.VERTICAL]),
  scrollbar: PropTypes.bool,
  speed: PropTypes.number,
};
